import {AppConfig} from '../utils/config'

const initialState = AppConfig;

initialState.secondLayer = {
    enabled: false,
    layerId: null,
    field: null,
    sldBody: null,
    sldId: null,
    styleData: { breaks: [], opacity: 1 },
    opacity: 1
};

const MapReducer = (state = initialState, action) => {
    let layers = state.layers;
    switch (action.type) {
        case "CHANGE_ZOOM":
            return {
                ...state,
                zoom: action.payload
            };
        case "CHANGE_COLORRAMP":
            return {
                ...state,
                colorRamp: action.payload
            };
        case "UPDATE_SLD":
            layers[action.payload.layerId] = {
                ...layers[action.payload.layerId],
                sldBody: action.payload.sldBody
            }
            return {
                ...state,
                layers: layers,
                styleData: action.payload.styleData
            };
        case "SET_ACTIVE_FIELD":
            return {
                ...state,
                activeField: action.payload
            }
        
        case "UPDATE_BMS":
            return {
                ...state,
                enabledBmaps: action.payload
            }
        case "TOGGLE_LAYER_STATE":
            Object.keys(layers).map(k=>{
                if(k==="allum_project:basemap"){
                    return;
                }
                if(k===action.payload.layerId){
                    layers[k].active = true;
                }else{
                    layers[k].active = false;
                }
            })
            return {
                ...state,
                layers: layers,
                activeLayer: action.payload.layerId
            }
        case "SET_SECOND_LAYER_ENABLED":
            return {
                ...state,
                secondLayer: {
                    ...state.secondLayer,
                    enabled: action.payload
                }
            };

        case "SET_SECOND_LAYER_SOURCE":
            return {
                ...state,
                secondLayer: {
                    ...state.secondLayer,
                    layerId: action.payload.layerId,
                    field: action.payload.field
                }
            };

        case "SET_SECOND_LAYER_STYLE":
            return {
                ...state,
                secondLayer: {
                    ...state.secondLayer,
                    styleData: action.payload
                }
            };

        case "SET_SECOND_LAYER_SLD":
            return {
                ...state,
                secondLayer: {
                    ...state.secondLayer,
                    sldBody: action.payload.sldBody,
                    sldId: action.payload.sldId
                }
            };

        case "SET_SECOND_LAYER_OPACITY":
            return {
                ...state,
                secondLayer: {
                    ...state.secondLayer,
                    opacity: action.payload
                }
            };

        default:
            return {
                ...state
            };
    }
};

export default MapReducer;